import {Pipe, PipeTransform} from '@angular/core';
import {StatesHelper} from '../../states/states.helper';
import Product from '../../_entities/products/product.entity';

@Pipe({
    name: 'productById',
    pure: true
})
export class ProductByIdPipe implements PipeTransform {
    transform(productId: number): Product {
        if (!+productId) return;
        return new Product(StatesHelper.productsEntitiesState.entities[productId]);
    }
}
